import { useState } from 'react'
import './LessonPlans.scss'
import { useEffect } from 'react'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import LessonPlanForm from '../LessonPlanForm/LessonPlanForm'
import LessonPlanCard from '../LessonPlanCard/LessonPlanCard'

const LessonPlans = ({ book, setLoadedBook }) => {
  const [loadedLessonPlans, setLoadedLessonPlans] = useState([])
  const MySwal = withReactContent(Swal)

  useEffect(() => {
    setLoadedLessonPlans(book.lessonPlans)
  }, [book])

  const sortedLessons = loadedLessonPlans
    ? loadedLessonPlans.sort((a, b) => a.chapter - b.chapter)
    : []

  function handleCreateLessonPlanModal() {
    MySwal.fire({
      showCancelButton: false,
      showConfirmButton: false,
      showCloseButton: true,
      title: <span style={{ color: '#FFC107' }}>Criar Plano de Aula</span>,
      html: (
        <LessonPlanForm
          book={book}
          setLoadedBook={setLoadedBook}
          setLoadedLessonPlans={setLoadedLessonPlans}
        />
      )
    })
  }

  return (
    <div className='lesson-plans-container'>
      <div className='row page-title lesson-plans-header'>
        <h1>Planos de aula</h1>
        <button
          type='button'
          className='button-full btn-save add-lesson-plan-button'
          onClick={handleCreateLessonPlanModal}
        >
          Adicionar
        </button>
      </div>
      {sortedLessons && sortedLessons.length > 0 && (
        <>
          <div className='row content-header'>
            <h3 className='list-title'>Lista de planos de aula</h3>
          </div>
          <div className='lesson-plans-list'>
            {sortedLessons.map((lesson) => (
              <LessonPlanCard
                key={lesson.id}
                lessonPlan={lesson}
                book={book}
                setLoadedBook={setLoadedBook}
                setLoadedLessonPlans={setLoadedLessonPlans}
              />
            ))}
          </div>
        </>
      )}
    </div>
  )
}

export default LessonPlans
